import _ from 'lodash';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const COLUMN_FREEZE_LINE = '__freezeline__';

export const ColumnSections = ['prompt', 'annotations', COLUMN_FREEZE_LINE, 'metadata', 'response'];

export type AuditLayoutStore = {
  showConfig: boolean;
  setShowConfig: (show: boolean) => void;
  toggleShowConfig: () => void;

  columnWidthEx: number;
  setColumnWidthEx: (width: number) => void;

  showBefore: boolean;
  setShowBefore: (show: boolean) => void;
  toggleShowBefore: () => void;

  showAfter: boolean;
  setShowAfter: (show: boolean) => void;
  toggleShowAfter: () => void;

  columnDisplayOrder: string[];
  setColumnDisplayOrder: (order: string[]) => void;

  sectionVisibility: { [key: string]: boolean };
  setSectionVisibility: (section: string, visible: boolean) => void;
  toggleSectionVisibility: (section: string) => void;

  hideUnselectedResponses: boolean;
  toggleHideUnselectedResponses: () => void;

  compactMode: boolean;
  toggleCompactMode: () => void;
};

export const useAuditLayoutStore = create<AuditLayoutStore>()(
  devtools(
    set => ({
      showConfig: true,
      setShowConfig: (show: boolean) => {
        set({ showConfig: show });
      },
      toggleShowConfig: () => {
        set(state => ({ showConfig: !state.showConfig }));
      },
      columnWidthEx: 90,
      setColumnWidthEx: (width: number) => {
        set({ columnWidthEx: width });
      },
      showBefore: true,
      setShowBefore: (show: boolean) => {
        set({ showBefore: show });
      },
      toggleShowBefore: () => {
        set(state => ({ showBefore: !state.showBefore }));
      },
      showAfter: true,
      setShowAfter: (show: boolean) => {
        set({ showAfter: show });
      },
      toggleShowAfter: () => {
        set(state => ({ showAfter: !state.showAfter }));
      },
      columnDisplayOrder: ColumnSections.slice(),
      setColumnDisplayOrder: (order: string[]) => {
        set({ columnDisplayOrder: order });
      },

      sectionVisibility: _.fromPairs(ColumnSections.map(section => [section, true])),
      setSectionVisibility: (section: string, visible: boolean) => {
        set(state => ({
          sectionVisibility: { ...state.sectionVisibility, [section]: visible },
        }));
      },
      toggleSectionVisibility: (section: string) => {
        set(state => ({
          sectionVisibility: {
            ...state.sectionVisibility,
            [section]: !state.sectionVisibility[section],
          },
        }));
      },
      hideUnselectedResponses: true,
      toggleHideUnselectedResponses: () => {
        set(state => ({ hideUnselectedResponses: !state.hideUnselectedResponses }));
      },
      compactMode: false,
      toggleCompactMode: () => {
        set(state => ({ compactMode: !state.compactMode }));
      },
    }),
    {
      name: 'chat-audit-layout',
    },
  ),
);
